export default __webpack_public_path__ + "static/media/sv_4.03d1cf6c.webp";